/**
* Функционал для нового форматирования таблицы
*/

window.UARM_TMCE_UTIL = window.UARM_TMCE_UTIL || {}

const table2Names = {
	table: {
		form: {
			enabledName: 'table2-table-form-enabled'
		},
		class: 'table2-tbl'
	},
	row: {
		form: {
			href: 'table2-table-row-href',
			isHref: 'table2-table-row-is-href'
		},
		attr: 'data-href',
		class: 'table__clickline'
	},
	rowHead: {
		class: 'table2__row_dark'
	},
	colType: {
		attr: 'vHead'
	},
	colHead: {
		class: 'table2__col_dark'
	}
}

const table2FormControl = {
	padding: 0,
	columns: 1,
	type: 'form',
	layout: 'grid',
	labelGapCalc: false,
	defaults: {
		type: 'textbox'
	},
	items: [
		{
			name: table2Names.table.form.enabledName,
			label: 'Адаптивная таблица',
			type: 'checkbox',
			tooltip: 'Если установить эту галочку, то таблица превратится в растягивающую, которая будет корректно отображаться на сайте.'
		},
		{
			name: 'title',
			minWidth: 300,
			label: 'Подсказка',
			tooltip: 'Всплывающая подсказкя к таблице.'
		}
	]
}

const table2RowControl = {
	type: 'form',
	labelGapCalc: false,
	padding: 0,
	layout: 'flex',
	columns: 1,
	defaults: {
		type: 'textbox',
		maxWidth: 50
	},
	items: [
		{
			name: table2Names.rowHead.class,
			type: 'listbox',
			label: 'Стиль строки',
			tooltip: 'Выбрать стиль для строки',
			maxWidth: null,
			values: [
				{text: 'Нет', value: ''},
				{text: 'Темный', value: 'table2__row_dark'}
			]
		},
		{
			name: table2Names.row.form.isHref,
			type: 'checkbox',
			label: 'Ссылка',
			tooltip: 'Если установить эту галочку, можно установить ссылку для строки'
		},
		{
			name: table2Names.row.form.href,
			type: 'textbox',
			label: 'Значение ссылки',
			tooltip: 'Укажите ссылку для строки',
			minWidth: 400,
			maxWidth: null
		}
	]
}

const table2ColControl = {
	type: 'form',
	labelGapCalc: false,
	padding: 0,
	layout: 'flex',
	columns: 1,
	defaults: {
		type: 'textbox',
		maxWidth: 50
	},
	items: [
		{
			type: 'listbox',
			name: table2Names.colType.attr,
			label: 'Тип столбца',
			minWidth: 300,
			maxWidth: null,
			values: [
				{text: 'Body', value: ''},
				{text: 'Header', value: 'vHead'}
			]
		},
		{
			name: table2Names.colHead.class,
			type: 'listbox',
			label: 'Стиль столбца',
			tooltip: 'Выбрать стиль для столбца',
			maxWidth: null,
			values: [
				{text: 'Нет', value: ''},
				{text: 'Темный', value: 'table2__col_dark'}
			]
		}
	]
}

const table2FormGetData = {
	onInit: function(dom, data, elm) {
		// если есть класс table2 - отмечаем чекбокс
		if (dom.getAttrib(elm, 'class').indexOf(table2Names.table.class) !== -1) {
			data[table2Names.table.form.enabledName] = true;
		}

		return data
	},
	onSubmit: function(dom, data, tableElm) {
		// чекбокс отмечен - ставим класс
		if (!!data[table2Names.table.form.enabledName]) {
			if (data['class'].indexOf(table2Names.table.class) === -1) {
				// если в классе не было признака table2 - устанавливаем
				dom.setAttrib(tableElm, 'class', data['class'] + ' ' + table2Names.table.class)
			}
		} else {
			// Вырезаем класс table2
			const elmClass = dom.getAttrib(tableElm, 'class').replace(table2Names.table.class, '')
			dom.setAttrib(tableElm, 'class', elmClass)
		}

		dom.setAttrib(tableElm, 'title', data['title']);

		return data
	}
}

const table2RowGetData = {
	onInit: function(dom, data, elm) {
		if (dom.getAttrib(elm, 'class').indexOf(table2Names.row.class) !== -1) {
			data[table2Names.row.form.isHref] = true
			data[table2Names.row.form.href] = dom.getAttrib(elm, table2Names.row.attr)
		}

		if (dom.getAttrib(elm, 'class').indexOf(table2Names.rowHead.class) !== -1) {
			data[table2Names.rowHead.class] = 'table2__row_dark'
		}

		return data
	},
	onSubmit: function(dom, data, rowElm) {
		if (!!data[table2Names.row.form.isHref]) {
			const href = data[table2Names.row.form.href];

			if (data['class'].indexOf(table2Names.row.class) === -1) {
				dom.setAttrib(rowElm, table2Names.row.attr, href)
				dom.setAttrib(rowElm, 'class', data['class'] + ' ' + table2Names.row.class)
			} else {
				dom.setAttrib(rowElm, table2Names.row.attr, href)
			}
		} else {
			const elmClass = dom.getAttrib(rowElm, 'class').replace(table2Names.row.class, '')
			dom.setAttrib(rowElm, 'class', elmClass)

			rowElm.removeAttribute(table2Names.row.attr)
		}
		/*Настройка стиля шапки таблицы Светлая/Темная https://pirs.wflow.oooinex.ru/boards/9?selectedIssue=PIRS-2-5329*/
		if (data[table2Names.rowHead.class] == 'table2__row_dark') {
			/*Добавляем стиль для темной шапки таблицы .table2__row_dark*/
			if (data['class'].indexOf(table2Names.rowHead.class) === -1) {
				dom.setAttrib(rowElm, 'class', data['class'] + ' ' + table2Names.rowHead.class)
			}
		} else {
			/*Удаляем стиль для темной шапки таблицы .table2__row_dark*/
			const elmClass = dom.getAttrib(rowElm, 'class').replace(table2Names.rowHead.class, '')
			dom.setAttrib(rowElm, 'class', elmClass)
		}

		return data
	}
}

const table2ColGetData = {
	onInit: function(dom, data, elm) {
		if (dom.getAttrib(elm, 'class').indexOf(table2Names.colHead.class) !== -1) {
			data[table2Names.colHead.class] = 'table2__col_dark'
		}
		if (dom.getAttrib(elm, 'data-vHead') == 'vHead') {
			data[table2Names.colType.attr] = 'vHead'
		}

		return data
	},
	onSubmit: function(dom, data, colElm) {
		/*Настройка стиля шапки таблицы Светлая/Темная https://pirs.wflow.oooinex.ru/boards/9?selectedIssue=PIRS-2-5329*/
		if (data[table2Names.colHead.class] == 'table2__col_dark') {
			/*Добавляем стиль для темной шапки таблицы .table2__col_dark*/
			dom.setAttrib(colElm, 'class', table2Names.colHead.class)
		} else {
			/*Удаляем стиль для темной шапки таблицы .table2__col_dark*/
			const elmClass = dom.getAttrib(colElm, 'class').replace(table2Names.colHead.class, '')
			dom.setAttrib(colElm, 'class', elmClass)
		}

		if (data[table2Names.colType.attr] == 'vHead') {
			dom.setAttrib(colElm, 'data-vHead', table2Names.colType.attr)
		} else {
			const elmAttr = dom.getAttrib(colElm, 'data-vHead').replace(table2Names.colType.attr, '')
			dom.setAttrib(colElm, 'data-vHead', elmAttr)
		}

		return data
	}
}

window.UARM_TMCE_UTIL.table2RowControl = table2RowControl;
window.UARM_TMCE_UTIL.table2RowGetData = table2RowGetData;

window.UARM_TMCE_UTIL.table2ColControl = table2ColControl;
window.UARM_TMCE_UTIL.table2ColGetData = table2ColGetData;

window.UARM_TMCE_UTIL.table2FormControl = table2FormControl;
window.UARM_TMCE_UTIL.table2FormGetData = table2FormGetData;
